// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"PlanteeAppLink_wrapper__mOyqr","icon":"PlanteeAppLink_icon__fJBOu"};